import React from 'react';
import { Task, Quadrant } from '../types';
import { Trash2, Play } from 'lucide-react';

interface TaskCardProps {
  task: Task;
  onDelete: (id: string) => void;
  onFocus?: (id: string) => void;
  isCompact?: boolean;
}

export const TaskCard: React.FC<TaskCardProps> = ({ task, onDelete, onFocus, isCompact }) => {
  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('taskId', task.id);
    e.dataTransfer.effectAllowed = 'move';
  };

  const getQuadrantColor = (q: Quadrant) => {
    switch (q) {
      case Quadrant.Do: return 'border-l-4 border-l-red-500 dark:border-l-red-600';
      case Quadrant.Schedule: return 'border-l-4 border-l-blue-500 dark:border-l-blue-600';
      case Quadrant.Delegate: return 'border-l-4 border-l-yellow-500 dark:border-l-yellow-600';
      case Quadrant.Eliminate: return 'border-l-4 border-l-emerald-500 dark:border-l-emerald-600';
      default: return '';
    }
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      className={`bg-white dark:bg-dark-surface rounded-md shadow-sm border border-gray-200 dark:border-dark-border p-3 mb-2 cursor-grab active:cursor-grabbing hover:shadow-md transition-all group relative flex items-start justify-between gap-2 ${getQuadrantColor(task.quadrant)}`}
    >
      <div className="flex-1">
        <p className={`text-sm text-gray-800 dark:text-gray-200 font-medium ${task.status === 'DONE' ? 'line-through text-gray-400 dark:text-gray-600' : ''}`}>
          {task.title}
        </p>
        {!isCompact && (
          <div className="mt-1 flex gap-2">
            <span className="text-xs text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-gray-800 px-1.5 py-0.5 rounded border border-gray-100 dark:border-gray-700">
               {task.status.toLowerCase()}
            </span>
          </div>
        )}
      </div>
      
      <div className="flex flex-col gap-1 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
        {onFocus && task.status !== 'DONE' && (
           <button 
             onClick={(e) => {
               e.stopPropagation();
               onFocus(task.id);
             }}
             className="text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 p-1"
             title="Focus Mode"
           >
             <Play size={14} />
           </button>
        )}
        <button 
          onClick={(e) => {
            e.stopPropagation();
            onDelete(task.id);
          }}
          className="text-gray-400 hover:text-red-500 dark:hover:text-red-400 p-1"
          aria-label="Delete task"
        >
          <Trash2 size={14} />
        </button>
      </div>
    </div>
  );
};